/* eslint-disable jira/filename-case */

import type { PreloadedQuery } from 'react-relay';
import type { RouteResource } from '@atlassian/react-resource-router';
import PreviewPanelRelayQuery, {
	type PreviewPanelQuery,
} from '@jira/issue__preview-panels/src/__generated__/PreviewPanelQuery.graphql.ts';
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';

export const previewPanelStateResource: RouteResource<
	PreloadedQuery<PreviewPanelQuery, Record<string, unknown>>
> = createRelayResource<PreviewPanelQuery>({
	type: 'RELAY_RESOURCE_TYPE_PREVIEW_PANEL',
	// oxlint-disable-next-line no-explicit-any
	getQuery: (_: any, { tenantContext: { cloudId } }) => ({
		parameters: PreviewPanelRelayQuery,
		variables: { cloudId },
		options: { fetchPolicy: 'store-and-network' },
	}),
	isCritical: true,
	isBrowserOnly: false,
});
